module.exports = __webpack_public_path__ + "static/media/computer_reparatie.b9cedf54.jpg";